
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from "../../../Redux/Slice/AxiosInstance/AxiosInstance";
import Cookies from "js-cookie";

const Firm = Cookies.get("Firm");
const DataBase = Cookies.get("Database");


export const StageFilters = createAsyncThunk("MillStage/StageFilters", async (data) => {
    try {
        const response = await api.post(
            `/MillStage/StageFilters`,
            {
                FirmIDs: Firm,
                DataBase: DataBase,
                
            },
          
        );
        return response.data;
    } catch (error) {
        throw new Error(error.response ? error.response.data : "Network Error");
    }
});

export const GreyStageBalance = createAsyncThunk("MillStage/GreyStageBalance", async (data) => {
    try {
        const response = await api.post(
            `/MillStage/GreyStageBalance`,
            {
                GroupIds: data.GroupIds ? data.GroupIds : " ",
                StageIds: data.StageIds ? data.StageIds : " ",
                PartyIDs: data.PartyIDs ? data.PartyIDs : " ",
                DataBase: DataBase,
                FirmIDs: Firm,
            },
          
        );
        return response.data;
    } catch (error) {
        throw new Error(error.response ? error.response.data : "Network Error");
    }
});



export const StgWiseInOutBalance = createAsyncThunk("MillStage/StgWiseInOutBalance", async (data) => {
    try {
        const response = await api.post(
            `/MillStage/StgWiseInOutBalance`,
            {
                FirmIDs: Firm,
                GroupIds: data.GroupIds ? data.GroupIds : " ",
                StageIDs: data.StageIDs ? data.StageIDs : " ",
                StartDate: data.StartDate ? data.StartDate : " ",
                EndDate: data.EndDate ? data.EndDate : " ",
                DataBase: DataBase,
                
            },
          
        );
        return response.data;
    } catch (error) {
        throw new Error(error.response ? error.response.data : "Network Error");
    }
});

export const LotWiseReport = createAsyncThunk("MillStage/LotWiseReport", async (data) => {
    try {
        const response = await api.post(
            `/MillStage/LotWiseReport`,
            {
                FirmIDs: Firm,
                GroupIds: data.GroupIds ? data.GroupIds : " ",
                DataBase: DataBase,
                
            },
          
        );
        return response.data;
    } catch (error) {
        throw new Error(error.response ? error.response.data : "Network Error");
    }
});

export const GrpWiseStagWiseBalance = createAsyncThunk("MillStage/GrpWiseStagWiseBalance", async (data) => {
    try {
        const response = await api.post(
            `/MillStage/GrpWiseStagWiseBalance`,
            {
                FirmIDs: Firm,
                GroupIds: data.GroupIds ? data.GroupIds : "",
                StartDate: data.StartDate ? data.StartDate : "",
                EndDate: data.EndDate ? data.EndDate : "",
                DataBase: DataBase,
                
            },
          
        );
        return response.data;
    } catch (error) {
        throw new Error(error.response ? error.response.data : "Network Error");
    }
});

export const GrpWiseStagWiseDtlReport = createAsyncThunk("MillStage/GrpWiseStagWiseDtlReport", async (data) => {
    try {
        const response = await api.post(
            `/MillStage/GrpWiseStagWiseDtlReport`,
            {
                FirmIDs: Firm,
                GroupIds: data.GroupIds ? data.GroupIds : "",
                StageIds: data.StageIds ? data.StageIds : "",
                StartDate: data.StartDate ? data.StartDate : "",
                EndDate: data.EndDate ? data.EndDate : "",
                DataBase: DataBase,
                
            },
          
        );
        return response.data;
    } catch (error) {
        throw new Error(error.response ? error.response.data : "Network Error");
    }
});

export const GrpPartyDtlReport = createAsyncThunk("MillStage/GrpPartyDtlReport", async (data) => {
    try {
        const response = await api.post(
            `/MillStage/GrpPartyDtlReport`,
            {
                FirmIDs: Firm,
                GroupIds: data.GroupIds ? data.GroupIds : "",
                StageIds: data.StageIds ? data.StageIds : "",
                PartyIds: data.PartyIds ? data.PartyIds : "",
                StartDate: data.StartDate ? data.StartDate : "",
                EndDate: data.EndDate ? data.EndDate : "",
                DataBase: DataBase,
                
            },
          
        );
        return response.data;
    } catch (error) {
        throw new Error(error.response ? error.response.data : "Network Error");
    }
});


export const CWiseBatchDtl = createAsyncThunk("MillStage/CWiseBatchDtl", async (data) => {
    try {
        const response = await api.post(
            `/MillStage/CWiseBatchDtl`,
            {
                FirmIDs: Firm,
                GroupIds: data.GroupIds ? data.GroupIds : "",
                StageIds: data.StageIds ? data.StageIds : "",
                MachineIds: data.MachineIds ? data.MachineIds : "",
                StartDate: data.StartDate ? data.StartDate : "",
                EndDate: data.EndDate ? data.EndDate : "",
                DataBase: DataBase,
                
            },
          
        );
        return response.data;
    } catch (error) {
        throw new Error(error.response ? error.response.data : "Network Error");
    }
});







export const MillstageSlice = createSlice({
    name: 'Store',
    initialState: {
        GreyStageBalancedata: null,
        StageFiltersdata: null,
        StgWiseInOutBalancedata: null,
        LotWiseReportdata: null,
        GrpWiseStagWiseBalancedata: null,
        GrpWiseStagWiseDtlReportdata: null,
        GrpPartyDtlReportdata: null,
        CWiseBatchDtldata: null,

        status: 'idle',
        error: null,
    },
    reducers: {
        GreyStageBalanceFun: (state) => {
            state.GreyStageBalancedata = "no";
        },
        StgWiseInOutBalanceFun: (state) => {
            state.StgWiseInOutBalancedata = "no";
        },
        LotWiseReportFun: (state) => {
            state.LotWiseReportdata = "no";
        },
        GrpWiseStagWiseBalanceFun: (state) => {
            state.GrpWiseStagWiseBalancedata = "no";
        },
        GrpWiseStagWiseDtlReportFun: (state) => {
            state.GrpWiseStagWiseDtlReportdata = "no";
        },
        GrpPartyDtlReportFun: (state) => {
            state.GrpPartyDtlReportdata = "no";
        },
        CWiseBatchDtlFun: (state) => {
            state.CWiseBatchDtldata = "no";
        },

    },
    extraReducers: (builder) => {
        builder
            .addCase(GreyStageBalance.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(GreyStageBalance.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.GreyStageBalancedata = action.payload;
            })
            .addCase(GreyStageBalance.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message;
            })


            .addCase(StageFilters.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(StageFilters.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.StageFiltersdata = action.payload;
            })
            .addCase(StageFilters.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message;
            })


            .addCase(StgWiseInOutBalance.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(StgWiseInOutBalance.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.StgWiseInOutBalancedata = action.payload;
            })
            .addCase(StgWiseInOutBalance.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message;
            })

            .addCase(LotWiseReport.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(LotWiseReport.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.LotWiseReportdata = action.payload;
            })
            .addCase(LotWiseReport.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message;
            })


            .addCase(GrpWiseStagWiseBalance.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(GrpWiseStagWiseBalance.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.GrpWiseStagWiseBalancedata = action.payload;
            })
            .addCase(GrpWiseStagWiseBalance.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message;
            })

            .addCase(GrpWiseStagWiseDtlReport.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(GrpWiseStagWiseDtlReport.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.GrpWiseStagWiseDtlReportdata = action.payload;
            })
            .addCase(GrpWiseStagWiseDtlReport.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message;
            })

            .addCase(GrpPartyDtlReport.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(GrpPartyDtlReport.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.GrpPartyDtlReportdata = action.payload;
            })
            .addCase(GrpPartyDtlReport.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message;
            })

            .addCase(CWiseBatchDtl.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(CWiseBatchDtl.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.CWiseBatchDtldata = action.payload;
            })
            .addCase(CWiseBatchDtl.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message;
            })



    },
});

export const { GreyStageBalanceFun, StgWiseInOutBalanceFun, LotWiseReportFun, GrpWiseStagWiseDtlReportFun, GrpPartyDtlReportFun, CWiseBatchDtlFun, GrpWiseStagWiseBalanceFun } = MillstageSlice.actions;

export default MillstageSlice.reducer;

